module.exports = __webpack_public_path__ + "img/3_25.c827b6e4.png";